export default [
  {
    path: '/livestreams',
    name: 'livestreams',
    component: () => import('../../views/livestreams/livestreams.vue'),
    meta: {
      pageTitle: 'Livestreams',
      breadcrumbs: ['Livestreams'],
    },
    children: [
      {
        path: '',
        name: 'livestreams-list',
        component: () => import('../../views/livestreams/list.vue')
      },
      {
        path: 'create',
        name: 'livestreams-create',
        component: () => import('../../views/livestreams/create.vue'),
        meta: {
          pageTitle: 'Create Livestream',
          breadcrumbs: ['Livestreams', 'Create'],
          permissions: ['livestreams.create']
        }
      },
      {
        path: ':id/edit',
        name: 'livestreams-edit',
        component: () => import('../../views/livestreams/edit.vue'),
        meta: {
          pageTitle: 'Edit Livestream',
          breadcrumbs: ['Livestreams', 'Edit'],
        }
      },
    ]
  }
]
